// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"536":"58c66010","777":"1e2e8e4d"}[chunkId] + ".chunk.js";
};